import React from 'react';

import { HeroRoot } from './HeroContainer.styles';

interface HeroContainerProps {
  children?: React.ReactNode;
  height?: number | string;
  borderRadius?: number | string;
  padding?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export const HeroContainer: React.FC<HeroContainerProps> = ({
  children,
  height,
  borderRadius,
  padding,
  className,
  style,
}) => {
  return (
    <HeroRoot
      heroHeight={height}
      heroBorderRadius={borderRadius}
      heroPadding={padding}
      className={className}
      style={style}
    >
      {children}
    </HeroRoot>
  );
};
